import './App.css';
import React from 'react';
import Home from './pages/Home';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="App">
      <Home />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;